import en from "./locales/en";
webix.i18n.spreadsheet = en;